import { render } from "./TsorTitles.vue?vue&type=template&id=fb32c5f0"
import script from "./TsorTitles.vue?vue&type=script&lang=js"
export * from "./TsorTitles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__